import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import { FaPaintBrush } from "react-icons/fa";

const PaintingHacksPage = () => {
  return (
    <Box minH="100vh" bg="white">
      {/* Hero Section */}
      <Box
        bg="white"
        py={{ base: 16, md: 24 }}
        px={{ base: 6, md: 12 }}
        textAlign="center"
      >
        <Heading
          as="h1"
          fontSize={{ base: "4xl", md: "6xl" }}
          fontWeight="800"
          color="gray.900"
          mb={6}
          fontFamily="'Work Sans', sans-serif"
        >
          DIY Painting Hacks
        </Heading>
        <Text
          fontSize={{ base: "lg", md: "xl" }}
          color="gray.600"
          maxW="2xl"
          mx="auto"
        >
          Want to make your painting project easier and more efficient? Check
          out these handy DIY painting hacks to achieve a professional finish
          and save time!
        </Text>
      </Box>

      {/* Content Section */}
      <Box bg="gray.50" py={{ base: 12, md: 20 }} px={{ base: 6, md: 12 }}>
        <Box maxW="1200px" mx="auto">
          {/* Tools & Materials Section */}
          <Box
            mb={12}
            bg="white"
            border="1px solid"
            borderColor="gray.200"
            borderRadius="xl"
            p={8}
            boxShadow="sm"
          >
            <Heading
              as="h2"
              fontSize="2xl"
              fontWeight="700"
              color="gray.900"
              mb={4}
            >
              Tools & Materials You'll Need
            </Heading>
            <List spacing={3}>
              <ListItem>
                <ListIcon as={FaPaintBrush} color="orange.500" />
                Paint Brushes and Rollers
              </ListItem>
              <ListItem>
                <ListIcon as={FaPaintBrush} color="orange.500" />
                Painter's Tape
              </ListItem>
              <ListItem>
                <ListIcon as={FaPaintBrush} color="orange.500" />
                Drop Cloths
              </ListItem>
              <ListItem>
                <ListIcon as={FaPaintBrush} color="orange.500" />
                Paint Tray
              </ListItem>
            </List>
          </Box>

          {/* Painting Hacks */}
          <VStack align="start" spacing={8}>
            {/* Hack 1 */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Heading
                as="h2"
                fontSize="2xl"
                fontWeight="700"
                color="gray.900"
                mb={2}
              >
                Hack 1: Use a Rubber Band for Drip-Free Edges
              </Heading>
              <Text fontSize="md" color="gray.600" mb={4}>
                Place a rubber band around the paint can to wipe off excess
                paint from your brush. This prevents drips and helps maintain
                clean edges while painting.
              </Text>
            </Box>

            {/* Hack 2 */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Heading
                as="h2"
                fontSize="2xl"
                fontWeight="700"
                color="gray.900"
                mb={2}
              >
                Hack 2: Painter's Tape for Perfect Lines
              </Heading>
              <Text fontSize="md" color="gray.600" mb={4}>
                Use painter's tape to mask off areas you don't want to paint.
                Press down the edges firmly to avoid paint seeping under the
                tape, ensuring crisp, clean lines.
              </Text>
            </Box>

            {/* Hack 3 */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Heading
                as="h2"
                fontSize="2xl"
                fontWeight="700"
                color="gray.900"
                mb={2}
              >
                Hack 3: Use a Bucket for a Roller
              </Heading>
              <Text fontSize="md" color="gray.600" mb={4}>
                When using a roller, pour your paint into a bucket instead of a
                tray. This allows for easier rolling and minimizes spills.
              </Text>
            </Box>

            {/* Hack 4 */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Heading
                as="h2"
                fontSize="2xl"
                fontWeight="700"
                color="gray.900"
                mb={2}
              >
                Hack 4: Keep Your Paint Fresh
              </Heading>
              <Text fontSize="md" color="gray.600" mb={4}>
                To keep leftover paint fresh, store it in an airtight container
                and place a piece of plastic wrap between the lid and the can
                before sealing.
              </Text>
            </Box>

            {/* Final Tip */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Text
                fontSize={{ base: "lg", md: "xl" }}
                fontWeight="700"
                color="gray.900"
              >
                Happy painting! These hacks will help you streamline your
                painting process and achieve beautiful results. Enjoy your DIY
                project!
              </Text>
            </Box>
          </VStack>
        </Box>
      </Box>
    </Box>
  );
};

export default PaintingHacksPage;
